import { AxiosResponse } from 'axios'
import { stringify } from 'qs'
import { HttpClient } from '@opallabs/api'
import { PhaseItemFetchParams } from '../workflow/types'

type PhaseItemsFetcher = (arg: PhaseItemFetchParams) => Promise<AxiosResponse>

export const fetchPhaseItems: PhaseItemsFetcher = ({
  fields,
  filter,
  include,
  page,
  sort,
  expose,
}) => {
  const queryString = stringify(
    {
      fields,
      filter,
      include: include.join(','),
      page,
      sort,
      expose,
    },
    {
      arrayFormat: 'brackets',
    }
  )

  return HttpClient().get(`/phase_items/v2?${queryString}`)
}
